import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'components/Button';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { Container } from 'styles/pages/product-detail/navAction';

const Header = () => {
  const history = useHistory();
  return (
    <Container>
      <Button
        containerStyle={{
          fontSize: '12px',
          border: '1px solid #ccc',
          borderRadius: '50px',
          padding: '1px 5px',
          lineHeight: '1.5',
          textTransform: 'inherit',
          color: 'inherit',
          fontWeight: '400',
        }}
        startIcon={<NavigateBeforeIcon />}
        variant='text'
        title='Back'
        onClick={() => history.goBack()}
      />
    </Container>
  );
};

export default Header;
